import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=50b3773e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b3773e')) {
      api.createRecord('50b3773e', component.options)
    } else {
      api.reload('50b3773e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=50b3773e&", function () {
      api.rerender('50b3773e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8XRiGNrO6jBqL/JS/comp/ImgFallback.vue"
export default component.exports